import SlimSelect from 'slim-select';
$(function() {
    const $select = $('select');

    if ($select) {
        $select.each(function (i, e) {
            new SlimSelect({
                select: e,
                settings: {
                    showSearch: false
                }
            })
        });
    }
});
